// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".header-footer." + "6113868e3e12d428114c" + ".js";
};